const calculateShiftDuration = (shift) => {
    if (!shift?.startAt || !shift?.endAt) return 0;
    const startTime = new Date(shift.startAt).getTime();
    const endTime = new Date(shift.endAt).getTime();
    return (endTime - startTime) / 1000;
};

const calculateShiftDurationHours = (shift) => {
    if (!shift?.startAt || !shift?.endAt) return 0;
    const startTime = new Date(shift.startAt).getTime();
    const endTime = new Date(shift.endAt).getTime();
    return (endTime - startTime) / (1000 * 60 * 60);
};

const sumWorkTimeData = (workTimeData, field) => {
    if (!Array.isArray(workTimeData) || workTimeData.length === 0) return 0;
    return workTimeData.reduce((sum, workTime) => sum + (workTime[field] || 0), 0);
};

const calculateShiftTime = (workTimeData, shifts) => {
    const fromWorkTimeData = sumWorkTimeData(workTimeData, 'shiftTime');
    if (fromWorkTimeData > 0) return fromWorkTimeData;
    return shifts.reduce((sum, shift) => sum + calculateShiftDuration(shift), 0);
};

const calculateWorkTime = (workTimeData, shiftTime) => {
    const fromWorkTimeData = sumWorkTimeData(workTimeData, 'workTime');
    if (fromWorkTimeData > 0) return fromWorkTimeData;
    return shiftTime;
};

const calculatePauseTime = (workTimeData) => {
    return sumWorkTimeData(workTimeData, 'pauseTime');
};

const getUniqueDays = (shifts) => {
    const uniqueDays = new Set();
    shifts.forEach((shift) => {
        if (shift?.startAt) {
            const date = new Date(shift.startAt);
            const dateKey = `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
            uniqueDays.add(dateKey);
        }
    });
    return uniqueDays.size;
};

export const calculateEntityStats = (shifts, workTimeData, allShifts, entityType, entityId) => {
    if (!shifts?.length) {
        return {
            revenue: 0,
            daysWorked: 0,
            euroPerKm: 0,
            hoursWorked: 0,
            shiftTime: 0,
            workTime: 0,
            pauseTime: 0,
        };
    }

    const totalRevenue =
        shifts.reduce((acc, shift) => acc + (shift.finalTotalAmount || 0), 0) / 100;
    const totalDistance = shifts.reduce((acc, shift) => acc + (shift.totalDistance || 0), 0) / 1000;
    const hiredDistance = shifts.reduce((acc, shift) => acc + (shift.hiredDistance || 0), 0) / 1000;
    const emptyDistance = totalDistance - hiredDistance;
    const emptyDistancePercent = totalDistance > 0 ? (emptyDistance / totalDistance) * 100 : 0;
    const occupancyRate = totalDistance > 0 ? (hiredDistance / totalDistance) * 100 : 0;
    const euroPerKm = totalDistance > 0 ? totalRevenue / totalDistance : 0;
    const hoursWorked = shifts.reduce((sum, shift) => sum + calculateShiftDurationHours(shift), 0);

    const shiftTime = calculateShiftTime(workTimeData, shifts);
    const workTime = calculateWorkTime(workTimeData, shiftTime);
    const pauseTime = calculatePauseTime(workTimeData);
    const daysWorked = getUniqueDays(shifts);

    return {
        revenue: totalRevenue,
        daysWorked,
        euroPerKm,
        hoursWorked,
        shiftTime,
        workTime,
        pauseTime,
        emptyDistancePercent,
        occupancyRate,
        totalDistance,
        hiredDistance,
        emptyDistance,
    };
};
